<script>
import Layout from "@/router/layouts/auth";
import { mapActions, mapState } from "vuex";

export default {
  components: { Layout },
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      error: "",
      submitted: false,
    };
  },
  computed: {
    ...mapState({ afiliadoAuth: (s) => s.afiliadoAuth }),
  },
  created() {
    if (this.afiliadoAuth.status.loggedIn) {
      this.$router.push("/afiliado");
    }
  },
  methods: {
    ...mapActions("afiliadoAuth", ["login"]),
    handleSubmit() {
      this.submitted = true;
      this.error = "";
      if (!this.email || !this.password) return;

      this.loading = true;
      this.login({ email: this.email, password: this.password })
        .catch((msg) => {
          this.error = msg || "E-mail e/ou senha incorretos.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 pb-2 text-center">
          <router-link tag="a" to="/">
            <img class="w-100" style="max-width: 250px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-5">
          <h5 class="text-center mb-4">Acesso de Afiliado</h5>
          <b-form @submit.prevent="handleSubmit">
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <b-form-group label="E-mail" label-for="email">
              <b-form-input
                v-model="email"
                type="email"
                :class="{ 'is-invalid': submitted && !email }"
              ></b-form-input>
              <div v-if="submitted && !email" class="invalid-feedback">O e-mail é obrigatório.</div>
            </b-form-group>
            <b-form-group label="Senha" label-for="password">
              <b-form-input
                v-model="password"
                type="password"
                :class="{ 'is-invalid': submitted && !password }"
              ></b-form-input>
              <div v-if="submitted && !password" class="invalid-feedback">A senha é obrigatória.</div>
            </b-form-group>
            <div class="mt-4">
              <b-button :disabled="loading" type="submit" variant="default" class="btn-lg btn-block">
                Entrar
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white"></b-spinner>
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </Layout>
</template>
